export default __webpack_public_path__ + "static/media/physicalCard.7b517836.png";